import { Controller } from 'stimulus'

class ConfirmationCountdownController extends Controller {
  static values = {
    id: String
  }

  connect () {
    this.countdownElement = $(`#countdown-${this.idValue}`)

    this.countdownInterval = setInterval(() => {
      this.updateCountdown()
    }, 1000)
  }

  disconnect () {
    clearInterval(this.countdownInterval)
  }

  updateCountdown () {
    const remainingTime = ConfirmationCountdownController.calculateJourneyRemainingTime($(this.countdownElement).data('extra'))
    $(this.countdownElement).find('.alert--content-text-remaining').html(`<b>${remainingTime[0]}</b>`)

    // If the time is up remove the journey confirmation form
    if (remainingTime[1] === 0) {
      $(this.countdownElement).parent().parent().remove()
      return
    }

    if (this.countdownElement.hasClass('hidden')) {
      this.countdownElement.removeClass('hidden')
      // We need to update the external iframe height after rendering the countdown component
      // since it will increase the container's overall height
      updateIframe()
    }
  }

  /*
  * Calculates the difference between two unix timestamps
  * returning the human readable formatted remaining time
  *
  * @param {integer} journeyEndDate - The journey end timestamp
  * @param {integer} startingTime - Initial timestamp (defaults to current time)
  * @param {integer} seconds - Number of seconds to add to startingTime (defaults to 7 days)
  * @return {array} An array with the formatted remaining time string and the remaining seconds (if < 1 minute)
  */
  static calculateJourneyRemainingTime (journeyEndDate, startingTime = new Date().getTime(), seconds = 604800) {
    const endDate = journeyEndDate + seconds * 1000
    let difference = endDate - startingTime

    const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24)
    difference -= daysDifference * 1000 * 60 * 60 * 24

    const hoursDifference = Math.floor(difference / 1000 / 60 / 60)
    difference -= hoursDifference * 1000 * 60 * 60

    const minutesDifference = Math.floor(difference / 1000 / 60)
    difference -= minutesDifference * 1000 * 60

    const secondsDifference = Math.floor(difference / 1000)

    if (daysDifference > 0) {
      return [`${daysDifference} ${daysDifference === 1 ? 'day' : 'days'}`, null]
    }
    if (hoursDifference > 0) {
      return [`${hoursDifference} ${hoursDifference === 1 ? 'hour' : 'hours'}`, null]
    }
    if (minutesDifference > 0) {
      return [`${minutesDifference} ${minutesDifference === 1 ? 'minute' : 'minutes'}`, null]
    }

    return [`${secondsDifference} ${secondsDifference === 1 ? 'second' : 'seconds'}`, secondsDifference]
  }
}

export default ConfirmationCountdownController
